import { useEffect, useState } from "react";
import { Card, Form, Button, Alert } from "react-bootstrap";
import { getOrg, putComunidad } from "../../controllers/org";
import Loading from "../loading/Loading";
import { useAuth } from "../auth/AuthProvider";

function CrearComunidad({ org, onSuccess, defaultRegion, defaultDiocesis }) {
  const [diocesis, setDiocesis] = useState(defaultDiocesis);
  const [region, setRegion] = useState(defaultRegion);
  const [nombreComunidad, setNombreComunidad] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState();
  const [o, setO] = useState(org);
  const { token } = useAuth();

  useEffect(() => {
    if (!o && !(defaultDiocesis && defaultRegion)) {
      loadOrg();
    }
  }, []);

  useEffect(() => {
    if (org) {
      setO(org);
    }
  }, [org]);

  useEffect(() => {
    if (!region) {
      setDiocesis();
    }
  }, [region]);

  async function loadOrg(){
    let o = await getOrg();
    setO(o);
  }
  
  async function submit(e) {
    e.preventDefault();
    setIsLoading(true);
    let a;
    try {
      await putComunidad(nombreComunidad, diocesis, token);
      a = <Alert key='alert' variant='success' dismissible>Se creó la comunidad <b>{nombreComunidad}</b> con éxito.</Alert>;
      setRegion();
      setNombreComunidad('');
      if (onSuccess && typeof onSuccess === 'function') {
        onSuccess();
      }
    }
    catch (e) {
      a = <Alert key='alert' variant='danger' dismissible>Error al crear comunidad.<br/><br/>{e.message}.</Alert>;
    }
    setIsLoading(false);
    if (a) {
      setAlert(a);
    }
  }

  function generateRegionOptions(){
    return o.regiones.map((it, idx) => {
      return <option value={it.region_id} key={'crear-comunidad-region-option-' + it.region_id}>{it.label}</option>;
    });
  }

  function renderDiocesisOptions() {
    if (!region) {
      return [
        <option value={null} key={`crear-comunidad-diocesis-option-null`}>-- Selecciona una región --</option>
      ]
    }
    let d = o.diocesis.filter(d => d.region_id === region);
    d.unshift({ value: null, label: '-- Selecciona una diócesis -- '});
    return d.map(d => <option value={d.diocesis_id} key={`crear-comunidad-diocesis-option-${d.diocesis_id}`}>{d.label}</option> );
  }

  if (isLoading) {
    return <Card>
      <Card.Header>Crear Comunidad</Card.Header>
      <Card.Body><Loading text="Creando comunidad..." /></Card.Body>
    </Card>
  }
  if (!org && !defaultDiocesis && !defaultRegion) {
    return <Card>
      <Card.Header>Crear Comunidad</Card.Header>
      <Card.Body><Loading text="Cargando..." /></Card.Body>
    </Card>
  }

  return <Card>
    <Card.Header>Crear Comunidad</Card.Header>
    <Card.Body>
      { alert }
      <Form>
        {!defaultRegion && <Form.Group className="mb-3">
          <Form.Label>Región</Form.Label>
          <Form.Select onChange={e => setRegion(parseInt(e.target.value))} defaultValue={region}>
            <option value={null}>-- Selecciona una región --</option>
            {generateRegionOptions()}
          </Form.Select>
        </Form.Group>}
        {!defaultDiocesis && <Form.Group className="mb-3">
          <Form.Label>Diócesis</Form.Label>
          <Form.Select onChange={e => setDiocesis(parseInt(e.target.value))}>
            { renderDiocesisOptions() }
          </Form.Select>
        </Form.Group>}
        <Form.Group className="mb-3">
          <Form.Label>Nombre de la comunidad</Form.Label>
          <Form.Control type="text" placeholder="Nombre de la comunidad" value={nombreComunidad} onChange={e => setNombreComunidad(e.target.value)} required />
        </Form.Group>
        {region && diocesis && nombreComunidad && <Form.Group className="mb-3 submit-buttons-wrapper">
          <Button key='submit-btn-new-comunidad' type='submit' variant='primary' onClick={submit}>Guardar comunidad</Button>
        </Form.Group>}
      </Form>
    </Card.Body>
  </Card>
}

export default CrearComunidad;
